import { Box, Button, Card, Container, Flex, Grid, Heading, Text, IconButton, Badge, Dialog, ScrollArea, Avatar } from '@radix-ui/themes';
import { ExclamationTriangleIcon, CheckIcon, ChevronDownIcon, TrashIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@radix-ui/react-icons';
import AddClassForm from '../forms/teacher/AddClassForm';
import { getTeacherCourses } from '../../api/courses';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MessageBox from '../common/MessageBox';
import { courseService } from '../../services/teacher/courseService';
import LoadingIndicator from '../shared/LoadingIndicator';
import { Info, DateTime } from 'luxon';
import { render } from 'react-dom';
import { useConfirmDialog } from '../../contexts/confirmDialog';
import { updateTeacherCourses } from '../../redux/slices/teacherAccountSlice';

//

//}




// uses the courses from the teacher account

const TeacherCourses = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const account = useSelector(state => state.teacherAccount);
  const dispatch = useDispatch();
  const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL

  const { showConfirmDialog } = useConfirmDialog();

  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     setLoading(true);
  //     const courses = await getTeacherCourses(account.details.id);
  //     console.log('courses', courses);
  //     setCourses(courses);
  //     setLoading(false);
  //   };
  //   console.log('account', account.courses);
  //   fetchCourses();
  // }, []);

  useEffect(() => {
    fetchCourseDetails(selectedCourse?.id);
  }, [selectedCourse])

  const fetchCourseDetails = async (courseId) => {
    setLoading(true);
    try {
      const response = await courseService.getCourseDetails(courseId);
      setCourseData(response.course);
      console.log(response);
    } catch (error) {
      console.error('Error fetching course details:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    console.log('course active teaching plan', account.courses);
  }, [account]);

  const addClass = () => {
    setShowAddModal(true);
  };

  const handleAddClassSubmit = (classData) => {
    // Handle the form submission
    console.log('New class data:', classData);
    setShowAddModal(false);
  };


  const deleteCourse = async (courseId) => {
    setLoading(true);
    try {
      await courseService.deleteCourse(courseId);
      console.log('Course deleted successfully');
      const updatedCourses = account.courses.filter(course => course.id !== courseId);
      console.log(updatedCourses)
      dispatch(updateTeacherCourses(updatedCourses));
      setSelectedCourse(null);
      setCourseData(null);
    } catch (error) {
      console.error('Error deleting course:', error);
    } finally {
      setLoading(false);
    }
  }



  const handleDeleteCourse = (course) => {
    showConfirmDialog(
      (<Box>
        <Text size="2" as="p" mb="2">Are you sure you want to delete this course. This action cannot be undone</Text>
        <Text size="1" as="p">This action will remove every subscription under you course, with all action such as schedule setting on this course</Text>
      </Box>),
      () => {
        deleteCourse(course.id);
      },
      {
        title: `Delete ${course.level.label} | ${course.subject.name}`,
        type: 'danger',
        icon: ExclamationTriangleIcon,
        confirmText: 'Delete',
        cancelText: 'Keep Course'
      });
  }


  const renderTeachingPlan = (plan) => {
    return (
      <Box key={plan.id} mb="4">
        {plan.status == "active" ? (
          <Flex key={plan.id} direction="column" justify="start" gap="2" mt="2">
            <Flex justify="between">
              <Text size="2" color="gray" as="p">{plan.period.title}</Text>
              <Badge variant="solid" size="2" color="">{plan.status}</Badge></Flex>
            <Text size="2" color="gray" as="p">
              {DateTime.fromISO(plan.period.start_date).toFormat("d'th', LLL")} - {DateTime.fromISO(plan.period.end_date).toFormat("d'th', LLL, yyyy")}
            </Text>

            {
              plan.lesson_structure != null && (
                <Flex gap="2" justify="start" align="center">
                  <img src={`${import.meta.env.VITE_PUBLIC_URL}${plan.lesson_structure.picture}`} alt="Lesson Structure" style={{ maxWidth: '150px', height: 'auto', borderRadius: '10px' }} />
                  <Box>
                    <Heading size="3" color="gray" as="p">{plan.lesson_structure.name}</Heading>
                    <Text size="2" color="gray" as="p">{plan.lesson_structure.description}</Text>
                    <Text size="2" color="gray" as="p">Start Lesson{plan.start_lesson_id}</Text>
                    <Text size="2" color="gray" as="p">End Lesson{plan.end_lesson_id}</Text>

                  </Box>

                </Flex>
              )
            }
          </Flex>) : (
          <Flex>
            <Text size="2" color="gray" as="p">{plan.period.title}</Text>
            <Badge>{plan.status}</Badge>
          </Flex>
        )}
      </Box>
    )
  }

  const renderCourseData = () => {
    return (
      <Grid columns="8" gap="4" mt="4" width="100%" maxWidth="1080px">
        <Box style={{ gridColumn: 'span 5' }}>
          <Card p="4">
            <Flex direction="row" justify="between" gap="2">
              <Text size="3" weight="bold">{courseData?.level?.label} | {courseData?.subject?.name}</Text>
            </Flex>

            <Flex gap="2" mt="2">
              {Info.weekdays('short').map((day, index) => (
                <Badge variant="solid" key={index} size="2" color={courseData.schedules.some(schedule => schedule.day === index) ? 'green' : 'gray'}>{day}</Badge>
              ))}
            </Flex>

            <Text size="2" color="gray" as="p" weight="bold" mt="4">Teaching plan</Text>
            {courseData.teaching_plans.length > 0 ? (
              courseData.teaching_plans.map((plan) => (
                renderTeachingPlan(plan)
              ))
            ) : (
              <Text size="2" color="gray" as="p">No teaching plan assigned</Text>
            )}
            <Button variant="ghost" size="1" color='red' onClick={() => handleDeleteCourse(selectedCourse)}><TrashIcon />Delete {courseData.level.label} | {courseData.subject.name}</Button>
          </Card>
        </Box>
        <Box style={{ gridColumn: 'span 3' }}>
          <Card>
            {courseData?.subscriptions && courseData?.subscriptions.length > 0 ? (
              <ScrollArea type="scroll" scrollbars="vertical">
                <Flex direction="column" gap="3">
                  {courseData.subscriptions.map((subscription) => (
                    <Flex key={subscription.id} align="center" gap="3">
                      <Avatar size="3" src={subscription.student.user.profile_picture} fallback={subscription.student.user.firstname[0]} />
                      <Text size="2">
                        {subscription.student.user.firstname} {subscription.student.user.lastname}
                      </Text>
                    </Flex>
                  ))}
                </Flex>
              </ScrollArea>
            ) : (
              <Text size="2" color="gray" as="p">
                No subscriptions found
              </Text>
            )}
          </Card>
        </Box>

      </Grid>
    )
  }

  if (account.courses.length == 0) {
    return (
      <MessageBox type="error" title="No courses found" message="You dont have any courses registered to your account. Visit your schedule to register a course." />
    )
  }

  return (
    <Box width="100%" p="4" style={{ maxWidth: '1080px', margin: '0 auto' }}>
      <Grid columns="8" gap="4">
        <Box style={{ gridColumn: 'span 6' }}>
          <Grid>
            <ScrollArea type="scroll" scrollbars="horizontal">
              <Flex gap="4" width={account.courses.length * 140}>
                {account.courses.map((course) => (
                  <Card
                    key={course.id}
                    style={{
                      cursor: 'pointer',
                      width: '120px',
                      height: '140px',
                      flexShrink: 0,
                      backgroundColor: selectedCourse?.id === course.id ? 'var(--accent-8)' : 'var(--gray-3)'
                    }}
                    onClick={() => setSelectedCourse(course)}
                  >
                    <Flex direction="column" justify="center" gap="1" align="center" p="2">
                      <Avatar size="4" fallback={course.subject.name[0]} />
                      <Text size="1" weight="bold" align="center">{course?.subject?.label || 'Unknown Subject'}</Text>
                      <Text size="1" color="gray">{course?.level?.label || 'Unknown Level'}</Text>
                      {selectedCourse?.id === course.id && <ChevronDownIcon />}
                    </Flex>
                  </Card>
                ))}
              </Flex>
            </ScrollArea>
          </Grid>
        </Box>
        <Card style={{ gridColumn: 'span 2' }}>
          <Flex direction="row" justify="between" mb="4">
            <Text size="2">Courses</Text>
            <Badge>{account.courses.length}</Badge>
          </Flex>
          <Button size="2" variant="soft" onClick={addClass}>
            <PlusIcon /> Add Class
          </Button>
        </Card>
      </Grid>

      <Box style={{ gridColumn: 'span 5' }}>
        {loading ? (
          <LoadingIndicator />
        ) : (
          courseData && renderCourseData()
        )}
      </Box>

      <Dialog.Root open={showAddModal} onOpenChange={setShowAddModal}>
        <Dialog.Content style={{ maxWidth: 450 }}>
          <Dialog.Title>Add New Class</Dialog.Title>
          <Dialog.Description size="2" mb="4">
            Fill in the details for your new class.
          </Dialog.Description>
          <AddClassForm onSubmit={handleAddClassSubmit} onCancel={() => setShowAddModal(false)} />
        </Dialog.Content>
      </Dialog.Root>
    </Box>
  );
};

export default TeacherCourses;
